import React, { Component } from 'react'
import { IconButton } from 'react-toolbox/lib/button'
import CSSModules from 'helpers/CSSModulesUtil'
import { mapProps, pure, compose, branch, renderComponent } from 'recompose'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'

import styles from './styles.scss'

const InfoButton = notifyHoc(IconButton)

const ModifyIconButton = ({ onEdit }) => {
  return (
    <InfoButton
      message={T.translate('pages.project.view.notification.editProjectSchedule')}
      onClick={onEdit}
      icon='edit'
    />
  )
}

const SaveModificationButton = ({ onSave, disabled }) => {
  return (
    <InfoButton
      message={T.translate('pages.project.view.notification.saveProjectSchedule')}
      onClick={onSave}
      disabled={disabled}
      icon='save'
    />
  )
}

export default compose(
  mapProps(
    ({ onSave, id, toggleEdit, edit, disabled }) => ({
      onEdit: toggleEdit,
      onSave: () => {
        onSave(id)
        toggleEdit()
      },
      edit,
      disabled
    })
  ),
  branch(
    ({ edit }) => edit,
    renderComponent(SaveModificationButton)
  ),
  pure,
  CSSModules(styles)
)(ModifyIconButton)
